import Raw from 'components/raw/raw';
import React, { FunctionComponent } from 'react';
import { Review } from '../types/review.type';

type ReviewContentProps = {
  review: Review;
  title?: string | null;
};

export const ReviewContent: FunctionComponent<ReviewContentProps> = ({
  review,
  title,
}) => (
  <>
    {review.reviewBody || title ? (
      <p>
        {title ? (
          <>
            <b>{title}</b>
            <br />
          </>
        ) : null}
        {review.reviewBody ? <Raw>{review.reviewBody}</Raw> : null}
      </p>
    ) : null}
    {review.privateComment ? (
      <p>
        <b>Remarque privée (non publiée sur le site)</b>
        <br />
        <Raw>{review.privateComment}</Raw>
      </p>
    ) : null}
    {review.comment ? (
      <p>
        <b style={{ color: '#f2711c' }}>Ce qui peut être amélioré</b>
        <br />
        <Raw>{review.comment}</Raw>
      </p>
    ) : null}
    {review.status === 'ko' && review.refuseReason ? (
      <p>
        <b style={{ color: '#db2828' }}>Raison du refus</b>
        <br />
        {review.refuseReason}
      </p>
    ) : null}
  </>
);
